<template>
  <info-box level="secondary" :item="item">
    <template v-slot:icon>
      <img alt="Gaz" :src="require('@ores/css-library/assets/img/icons/gas.svg')" />
    </template>
    <template>
      <h3 class="lib__text-uppercase">{{ $t('meter.gasMeterInstallation') }}</h3>
      <p>{{ $t('meter.gasMeterDescription') }}</p>
    </template>
    <template v-slot:annexe>
      <h3>{{ $t('meter.free') }} *</h3>
    </template>
  </info-box>
</template>

<script lang="ts">
import { Vue, Component, Prop } from 'vue-property-decorator'

@Component({
  name: 'gas-price-calculator',
})
export default class GasPriceCalculator extends Vue {
  //#region [Property]
  @Prop({ type: Boolean, required: false, default: false }) public readonly item!: boolean
  //#endregion
}
</script>